import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import './course.scss';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import {Button} from "components";
import {ReactComponent as ARROW_ICON} from "../../../assets/icons/arrow_icon.svg";
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination, Navigation} from "swiper";

import {ReactComponent as BUSINESS_EDUCATION_ICON} from 'assets/dashboard/business_education_icon.svg';

import COVER from "assets/slides/business_planning_checklist_course_cover_page.jpg"
import END from "assets/slides/business_planning_checklist_course_end_page.jpg"
import IMAGE_1 from "assets/slides/Business_planning_checklist_1.jpg"
import IMAGE_2 from "assets/slides/Business_planning_checklist_2.jpg"
import IMAGE_3 from "assets/slides/Business_planning_checklist_3.jpg"
import IMAGE_4 from "assets/slides/Business_planning_checklist_4.jpg"
import IMAGE_5 from "assets/slides/Business_planning_checklist_5.jpg"
import IMAGE_6 from "assets/slides/Business_planning_checklist_6.jpg"
import IMAGE_7 from "assets/slides/Business_planning_checklist_7.jpg"
import IMAGE_8 from "assets/slides/Business_planning_checklist_8.jpg"

interface Props {

}

const Course: React.FC<Props> = () => {
    const [swiper, setSwiperRef] = useState<any>(null);
    const navigate = useNavigate();
    const [active, setActive] = useState(0);
    const [course] = useState<{ title: string, slides: Array<string> }>(
        {title: "Market Penetration Strategies", slides: [COVER, IMAGE_1, IMAGE_2, IMAGE_3, IMAGE_4, IMAGE_5,IMAGE_6,IMAGE_7,IMAGE_8,END]}
    );

    const changeSide = (index: any) => {
        swiper.slideTo(index)
    }

    const handleActiveSlide = (e: any) => {
        setActive(e?.activeIndex)
    }

    return (
        <div className={'course'}>
            <div className={'course_heading'}>
                <div className={'course_heading_left'}>
                    <BUSINESS_EDUCATION_ICON/>
                    <h1>Courses</h1>
                </div>
                {/*<Button text={'Back'} type={'primary'}/>*/}
            </div>

            <div className="course_slides">
                <div className="course_slides_left scroll">
                    {
                        course.slides.map((image, index) => (
                            <div
                                className={['course_slides_left_slide', active === index && "active_side"].join(' ')}
                                key={"slides_indicator" + index}
                                onClick={() => changeSide(index)}
                            >
                                <img src={image} alt=""
                                />
                            </div>

                        ))
                    }
                </div>

                <div className="course_slides_right">
                    <div className="course_slides_right_slide">
                        <Swiper
                            onScroll={setSwiperRef}
                            onSlideChange={setSwiperRef}
                            onInit={setSwiperRef}
                            onSwiper={setSwiperRef}
                            onSlideChangeTransitionStart={handleActiveSlide}
                            slidesPerView={"auto"}
                            centeredSlides={false}
                            spaceBetween={30}
                            pagination={{
                                type: "fraction",
                            }}
                            navigation={false}
                            modules={[Pagination, Navigation]}
                            className="mySwiper"
                        >
                            {
                                course.slides.map((image, index) => (
                                    <SwiperSlide key={"slides" + index}>
                                        <img className={'course_slides_right_slide_image'} src={image} alt=""/>
                                    </SwiperSlide>

                                ))
                            }
                        </Swiper>
                    </div>
                    <div className="course_slides_right_bottom">
                        <div className="course_slides_right_bottom_nav">
                            <div className={'course_slides_right_bottom_nav_option'}
                                 onClick={() => swiper?.slidePrev()}>
                                <ARROW_ICON/>
                                <span>Prev</span>
                            </div>
                            <div className={'course_slides_right_bottom_nav_option'}
                                 onClick={() => swiper?.slideNext()}>
                                <span>Next</span>
                                <ARROW_ICON/>
                            </div>
                        </div>
                        <div className="course_slides_right_bottom_download">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Course;
